import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { spacing, position, layout, dimensions } from 'ui-box'
import { Pane, colors } from 'evergreen-ui'

export default class ProgressBar extends PureComponent {
  static propTypes = {
    /**
     * Composes some Box APIs.
     */
    ...spacing.propTypes,
    ...position.propTypes,
    ...layout.propTypes,
    ...dimensions.propTypes,

    /**
     * Specifies how of the task has been completed.
     * It must be a valid number between `0` and `max`.
     */
    value: PropTypes.number.isRequired,

    /**
     * The max prop, if present, must have a value greater than zero and
     * be a valid number. The default value is 1.
     */
    max: PropTypes.number.isRequired,

    /**
     * The height of the progress bar.
     */
    height: PropTypes.number.isRequired
  }

  static defaultProps = {
    height: 4,
    max: 1
  }

  render() {
    const { value, max, height, ...props } = this.props

    return (
      <Pane
        width="100%"
        backgroundColor={colors.neutral['30']}
        overflow="hidden"
        height={height}
        borderRadius={height / 2}
        {...props}
      >
        <Pane
          backgroundColor={colors.blue['500']}
          width={`${(value / max) * 100}%`}
          height={height}
          borderRadius={height / 2}
          css={{
            transition: 'width 0.2s ease-in-out'
          }}
        />
      </Pane>
    )
  }
}
